import { isToday, isYesterday } from "date-fns";

import { INotification } from "../types/Notification";

export type NotificationGroupKey = "today" | "yesterday" | "rest";

export type NotificationGroup = {
  key: NotificationGroupKey;
  items: INotification[];
};

/**
 * Три секции экрана: «Сегодня», «Вчера», «Остальные». Пустые секции не
 * возвращаем — заголовок без карточек под ним читался бы как ошибка.
 * Внутри секций — свежие сверху.
 */
export const groupNotifications = (
  notifications: INotification[],
): NotificationGroup[] => {
  const groups: Record<NotificationGroupKey, INotification[]> = {
    today: [],
    yesterday: [],
    rest: [],
  };

  [...notifications]
    .sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt))
    .forEach((item) => {
      const date = new Date(item.createdAt);
      const key: NotificationGroupKey = isToday(date)
        ? "today"
        : isYesterday(date)
          ? "yesterday"
          : "rest";

      groups[key].push(item);
    });

  return (["today", "yesterday", "rest"] as const)
    .filter((key) => groups[key].length > 0)
    .map((key) => ({ key, items: groups[key] }));
};
